import { Box } from '@mui/material';
import { initials } from '../utils';
import { INK, SOFT, BORDER } from './styles';

// Initials disc for a member row.
export default function Avatar({ name, email, size = 30 }) {
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: SOFT,
        border: `1px solid ${BORDER}`,
        color: INK,
        display: 'grid',
        placeItems: 'center',
        fontFamily: 'Rubik',
        fontSize: Math.round(size * 0.38),
        fontWeight: 600,
        flexShrink: 0,
      }}
    >
      {initials(name, email)}
    </Box>
  );
}
